export default __webpack_public_path__ + "static/media/bankh-inarticle.57ac9fc4.jpg";